const ALLOWED_DOMAIN = 'notoria.pl';

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function toAbsoluteUrl(ref) {
  if (ref.startsWith('//')) {
    return window.location.protocol + ref;
  }
  if (ref.startsWith('/')) {
    return window.location.origin + ref;
  }
  if (/^[a-z][a-z0-9+-]*:/i.test(ref)) {
    return ref;
  }
  return `${window.location.protocol}//${ref}`;
}

function getRedirectUrl(ref) {
  if (!ref) {
    return null;
  }

  let url;
  try {
    url = new URL(toAbsoluteUrl(ref));
  } catch (e) {
    return null;
  }

  if (url.protocol !== 'https:') {
    return null;
  }

  const hostname = url.hostname.toLowerCase();
  const isAllowed =
    hostname === ALLOWED_DOMAIN || hostname.endsWith(`.${ALLOWED_DOMAIN}`);

  return isAllowed ? url.href : null;
}

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}

export { checkStatus, getRedirectUrl, getQueryVariable, ALLOWED_DOMAIN };



// WEBPACK FOOTER //
// ./src/LoginForm/utils.js